angular.module("avant.filters").filter "AfterDate", 
["$location", 
($location) ->
  (items, date_field) ->
    cutoff_date = if $location.search()["m"]? and $location.search()["d"]? and $location.search()["y"]?
                    new Date(
                        (parseInt($location.search()["y"]) || 0),
                        (parseInt($location.search()["m"]) && parseInt($location.search()["m"]) - 1 || 0) # account for JS date
                        (parseInt($location.search()["d"]) || 0)
                      )
                  else
                    new Date()
    filtered = []
    angular.forEach items, (item) ->
      filtered.push item if (new Date(item[date_field])) >= cutoff_date
    filtered
]